import { Stack, useRouter } from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import Button from 'shared/components/vxl/Button/Button';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleLgText from 'shared/components/vxl/typography/primary/title/TitleLgText';
import theme from 'shared/styles/theme';

const AccountPending = () => {
  const router = useRouter();
  const { t: translatedText } = useTranslation('advance', {
    keyPrefix: 'accountPending',
  });
  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: false,
          statusBarHidden: false,
        }}
      />
      <View>
        <TitleLgText style={styles.title}>
          {translatedText('title')}
        </TitleLgText>
        <BodyBaseText>{translatedText('description')}</BodyBaseText>
      </View>
      <Button
        label={translatedText('button')}
        onPress={() => router.navigate('/')}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    justifyContent: 'space-between',
    padding: 16,
  },
  title: {
    marginBottom: theme.spacing.m,
  },
});

export default AccountPending;
